import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import s from './PasswordStrength.module.scss';

const PasswordStrength = ({
  password,
  confirmPassword,
  showConfirm = false
}: {
  password?: string;
  confirmPassword?: string;
  showConfirm?: boolean;
}) => {
  const isEmpty = !password;
  const lengthOk = password && password?.length >= 8;
  const isConfirmOk = !password || !confirmPassword;
  const hasDigit = password && password?.search(/[0-9]/) >= 0;
  const hasSpecial = password && /[\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`=+-]/.test(password);
  const hasCase = password && password?.search(/[a-z]/) >= 0 && password?.search(/[A-Z]/) >= 0;
  const isSame = password && confirmPassword && password == confirmPassword;

  return (
    <div className={s.PasswordStrength}>
      <div>
        <span className={cn(s.PasswordStrength__msg, { isActive: lengthOk, isEmpty })}>
          {'8 or more characters'}
        </span>
      </div>
      <div>
        <span className={cn(s.PasswordStrength__msg, { isActive: hasDigit, isEmpty: !lengthOk })}>
          {'Contains at least one digit'}
        </span>
      </div>
      <div>
        <span className={cn(s.PasswordStrength__msg, { isActive: hasSpecial, isEmpty: !lengthOk })}>
          {'Contains at least one special character'}
        </span>
      </div>
      <div>
        <span className={cn(s.PasswordStrength__msg, { isActive: hasCase, isEmpty: !lengthOk })}>
          {'Contains both lowercase and uppercase characters'}
        </span>
      </div>
      {showConfirm && (
        <div>
          <span className={cn(s.PasswordStrength__msg, { isActive: isSame, isEmpty: isConfirmOk })}>
            {'Confirm password does not match'}
          </span>
        </div>
      )}
    </div>
  );
};

export default observer(PasswordStrength);
